import I18n from 'I18n';
import { useState } from 'react';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UserObjectTimezoneModal from './UserObjectTimezoneModal';
import { getDeviceTimezone, getDisplayNameOld } from '../utils/timezoneUtils';
import usageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UserObjectTimezoneTooltip({
  stopPropagation = false
}) {
  var _I18n$moment$userObje, _I18n$moment, _I18n$moment$userObje2;
  // We should use the time zone from I18n.moment.userObjectTz()
  // and _not_ fetch the User object `hs_standard_time_zone` from the CRM.
  // This ensures that the time zone we display here is the one used to initialize moment.js.
  const timezone = ((_I18n$moment$userObje = (_I18n$moment = I18n.moment).userObjectTz) === null || _I18n$moment$userObje === void 0 || (_I18n$moment$userObje = _I18n$moment$userObje.call(_I18n$moment)) === null || _I18n$moment$userObje === void 0 || (_I18n$moment$userObje2 = _I18n$moment$userObje.tz) === null || _I18n$moment$userObje2 === void 0 ? void 0 : _I18n$moment$userObje2.call(_I18n$moment$userObje)) || getDeviceTimezone();
  const [showModal, setShowModal] = useState(false);
  if (!timezone) {
    // Something went wrong, device timezone should always be available
    return null;
  }
  return /*#__PURE__*/_jsxs("span", {
    onClick: e => {
      if (stopPropagation) {
        e.stopPropagation();
      }
    }
    // onMouseEnter fires two events for some reason (we only want one)
    ,
    onMouseLeave: e => {
      var _I18n$moment$userObje3, _I18n$moment2, _I18n$moment$userObje4;
      if (stopPropagation) {
        e.stopPropagation();
      }
      usageTracker.track('userObjectTz', {
        action: 'hover',
        tz: ((_I18n$moment$userObje3 = (_I18n$moment2 = I18n.moment).userObjectTz) === null || _I18n$moment$userObje3 === void 0 || (_I18n$moment$userObje3 = _I18n$moment$userObje3.call(_I18n$moment2)) === null || _I18n$moment$userObje3 === void 0 || (_I18n$moment$userObje4 = _I18n$moment$userObje3.tz) === null || _I18n$moment$userObje4 === void 0 ? void 0 : _I18n$moment$userObje4.call(_I18n$moment$userObje3)) || '',
        autoUpdate: 'unknown' // Don't want to fetch auto update prop at this point
      });
    },
    children: [/*#__PURE__*/_jsx(UIHelpIcon, {
      "data-test-id": "user-object-timezone-tooltip",
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        options: {
          onClick: () => setShowModal(true),
          timezone: getDisplayNameOld(timezone)
        },
        elements: {
          UILink
        },
        message: "ui-asset-management-lib.timezoneHelperTooltip.message_jsx"
      })
    }), showModal && /*#__PURE__*/_jsx(UserObjectTimezoneModal, {
      onSave: () => setShowModal(false),
      onCancel: () => setShowModal(false)
    })]
  });
}